import {
  SETTLEMENT_FETCH_REQUEST,
  SETTLEMENT_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_FETCH_REQUEST_FAILURE,
  SETTLEMENT_CLEAN_REQUEST,
  SETTLEMENT_DETAIL_FETCH_REQUEST,
  SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE,
  SETTLEMENT_DETAIL_CLEAN_REQUEST,
  SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_TRANSACTIONS_FETCH_REQUEST,
  SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_FAILURE,
  SETTLEMENT_TRANSACTIONS_CLEAN_REQUEST,
  SETTLEMENT_ATTEMPT_DETAIL_CLEAN_REQUEST,
  SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_FAILURE,
  SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST,
  SETTLEMENT_DRAFT_FETCH_REQUEST,
  SETTLEMENT_DRAFT_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_DRAFT_FETCH_REQUEST_FAILURE,
  SETTLEMENT_DRAFT_CLEAN_REQUEST,
  SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST,
  SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_SUCCESS,
  SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_FAILURE,
  SETTLEMENT_DRAFT_DETAIL_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const DRAFT_DETAIL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const SETTLEMENT_TRANSACTIONS__INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const settlementReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTLEMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data?.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case SETTLEMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};
export const settlementDraftReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTLEMENT_DRAFT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_DRAFT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data?.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case SETTLEMENT_DRAFT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_DRAFT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};
export const settlementDraftDetailReducer = (state, action) => {
  state = state || DRAFT_DETAIL_INITIAL_STATE;

  switch (action.type) {
    case SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [action.data?.data],
        errors: {},
      });

    case SETTLEMENT_DRAFT_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_DRAFT_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export const settlementDetailReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTLEMENT_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case SETTLEMENT_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

export const settlementAccountTransactionsReducer = (state, action) => {
  state = state || SETTLEMENT_TRANSACTIONS__INITIAL_STATE;
  switch (action.type) {
    case SETTLEMENT_TRANSACTIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state?.payload, ...action?.data?.transactions],
        errors: {},
        pagination: {
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecords || 0,
          totalPage: action.data.totalPages || 0,
          nextCursorId: action.data.nextCursorId,
        },
      });

    case SETTLEMENT_TRANSACTIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_TRANSACTIONS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });
    default:
      return state;
  }
};

export const settlementAttemptDetailReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state?.payload, ...action?.data?.batchAttempts],
        errors: {},
      });

    case SETTLEMENT_ATTEMPT_DETAIL_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SETTLEMENT_ATTEMPT_DETAIL_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
